import { useSelector } from 'react-redux';
import { t } from '../utilities/translator';
import { selectGlobalLoading } from '../appSlice';
import { LOCALE } from '../constants';

const HintsBlock = ({ beforeSearch }) => {
  const { hintsBlockLoading } = useSelector(selectGlobalLoading);

  const hintBlockImages = window.holidayFinder?.hintBlockImages;
  let localeImages = hintBlockImages && hintBlockImages[LOCALE];

  if (!hintBlockImages || (!localeImages && !hintBlockImages['__'])) {
    return null;
  } else if (!localeImages && hintBlockImages['__']) {
    localeImages = hintBlockImages['__'];
  }

  if (hintsBlockLoading) {
    return (
      <div className="hints-block-skeleton">
        <div className="hints-block-skeleton-item"></div>
        <div className="hints-block-skeleton-item"></div>
        <div className="hints-block-skeleton-item"></div>
      </div>
    );
  }

  return (
    <div className="hints-block">
      <div className="hint-block">
        <div className="hint-block-title-wrap">
          <h6 className="hint-block-title">{t('hintsBlock.title1')}</h6>
          <img alt="" src={localeImages.image1} />
        </div>

        <p className="hint-block-text">{t('hintsBlock.text1')}</p>
      </div>
      <div className="hint-block">
        <div className="hint-block-title-wrap">
          <h6 className="hint-block-title">{t('hintsBlock.title2')}</h6>
          <img alt="" src={localeImages.image2} />
        </div>

        <p className="hint-block-text">{t('hintsBlock.text2')}</p>
        <img className="arrow-left" src={localeImages.arrow1} alt="" />
        <img className="arrow-right" src={localeImages.arrow2} alt="" />
      </div>
      <div className="hint-block">
        <div className="hint-block-title-wrap">
          <h6 className="hint-block-title">{t('hintsBlock.title3')}</h6>
          <img alt="" src={localeImages.image3} />
        </div>
        <p className="hint-block-text">{t('hintsBlock.text3')}</p>
      </div>
    </div>
  );
};

export default HintsBlock;
